// src/buttons/SplitButton.tsx
import classNames from "classnames";
import { noop } from "lodash-es";
import React from "react";
import { MosaicWindowContext } from "../contextTypes.mjs";
import { OptionalBlueprint } from "../util/OptionalBlueprint.mjs";
import { DefaultToolbarButton } from "./MosaicButton.mjs";
var SplitButton = class extends React.PureComponent {
  static contextType = MosaicWindowContext;
  render() {
    return /* @__PURE__ */ React.createElement(
      DefaultToolbarButton,
      {
        title: "Split Window",
        className: classNames(
          "split-button",
          OptionalBlueprint.getIconClass(this.context.blueprintNamespace, "ADD_COLUMN_RIGHT")
        ),
        onClick: this.split
      }
    );
  }
  split = () => {
    this.context.mosaicWindowActions.split().then(() => {
      if (this.props.onClick) {
        this.props.onClick();
      }
    }).catch(noop);
  };
};
export {
  SplitButton
};
